export const PERMISSIONS_DICTIONARY = {
  tenantGroups: {
    name: 'Tenant Group',
    permissions: { read: 'View', add: 'Add', edit: 'Edit', delete: 'Delete' },
  },
  tenants: {
    name: 'Tenant',
    permissions: { read: 'View', add: 'Add', edit: 'Edit', delete: 'Delete' },
  },
  categories: {
    name: 'Category',
    permissions: { read: 'View', add: 'Add', edit: 'Edit', delete: 'Delete' },
  },
  policies: {
    name: 'Policy',
    permissions: { read: 'View', add: 'Add', edit: 'Edit', delete: 'Delete' },
  },
  netblocks: {
    name: 'Netblock',
    permissions: { read: 'View', add: 'Add', edit: 'Edit', delete: 'Delete' },
  },
  domains: {
    name: 'Domain',
  }
};
